const baseSize = 14;

function setRem() {
  const scale = document.documentElement.clientWidth / 1920;
  document.documentElement.style.fontSize =
    baseSize * Math.min(scale, 1.2) + "px";
  // 设置一个根据fontsize变化适应的scale
  window.scale = document.documentElement.style.fontSize / baseSize;
}

setRem();
window.onresize = function() {
  setRem();
}
